import { useOnboardingWizard } from "./OnboardingWizardProvider";
import { Check } from "lucide-react";

export function WizardProgress() {
  const {
    currentStep,
    totalSteps,
    completedSteps,
    totalPoints,
    maxPoints,
  } = useOnboardingWizard();
  const progressPercent = (totalPoints / maxPoints) * 100;

  return (
    <div className="w-full space-y-3">
      {/* Progress bar with nara-orange gradient */}
      <div className="relative h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full rounded-full transition-all duration-700 ease-out"
          style={{
            width: `${progressPercent}%`,
            background: "linear-gradient(90deg, #F69E47, #F8C552)",
          }}
        />
      </div>

      {/* Step dots */}
      <div className="flex items-center justify-center gap-1.5">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <div
            key={i}
            className={`
              h-2 w-2 rounded-full transition-all duration-300
              ${i === currentStep ? "h-2.5 w-2.5 bg-nara-orange" : ""}
              ${i < currentStep || completedSteps[i] ? "bg-nara-orange" : ""}
              ${i > currentStep && !completedSteps[i] ? "bg-muted-foreground/30" : ""}
            `}
          />
        ))}
      </div>

      {/* Points display */}
      <div className="text-center text-xs text-muted-foreground">
        {totalPoints} / {maxPoints} XP
      </div>
    </div>
  );
}
